import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import { TextField, Button } from '@material-ui/core';
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux';
import classNames from 'classnames';
import * as Actions from 'auth/store/actions/index';
import { bindActionCreators } from 'redux';
import Formsy from 'formsy-react';

const styles = theme => ({
    textField: {
        paddingLeft: '15px',
        paddingRight: '15px',
        width: '100%'
    }
});


class ChangePassword extends Component {

    state = {
        passwordSent: false,
        passwordWrong: false,
        OldPassword: '',
        NewPasswordOne: '',
        NewPasswordTwo: ''
    }

    handleChange = field_name => event => {
        let value = event.target.value;
        const updateData = {
            [field_name]: value
        }
        this.setState(updateData)
    }

    onSubmit = (model) => {
        if (this.state.OldPassword === '' || this.state.NewPasswordOne === '' || this.state.NewPasswordTwo === '') {
            this.setState({ passwordWrong: true })
            return false
        }

        this.props.checkPassword(this.state.OldPassword, this.props.auth.user.data.auth_id, this.state.NewPasswordOne)
        this.setState({
            OldPassword: '',
            NewPasswordOne: '',
            NewPasswordTwo: ''
        })
    }

    render() {
        const { classes, passwordChanged } = this.props
        return (
            <div>
                {this.passwordChanged(passwordChanged)}
                {this.wrongPassword(this.state.passwordWrong, passwordChanged)}
                <Formsy noValidate autoComplete="off"
                    onValidSubmit={this.onSubmit}
                    ref={(el) => this.myFormRef = el}
                >

                    <TextField
                        className={classNames(classes.textField)}
                        id="OldPassword"
                        name="OldPassword"
                        label="Old Password"
                        type="password"
                        margin="normal"
                        value={this.state.OldPassword}
                        onChange={this.handleChange('OldPassword')}
                    />
                    <TextField
                        className={classNames(classes.textField)}
                        id="NewPasswordOne"
                        name="NewPasswordOne"
                        label="New Password"
                        type="password"
                        validations={{
                            minLength: 4,
                            equalsField: 'NewPasswordTwo'
                        }}
                        validationErrors={{
                            equalsField: 'Passwords do not match',
                            minLength: 'Min character length is 4'
                        }}
                        required
                        margin="normal"
                        onChange={this.handleChange('NewPasswordOne')}
                        value={this.state.NewPasswordOne}
                    />
                    <TextField
                        className={classNames(classes.textField)}
                        id="NewPasswordTwo"
                        name="NewPasswordTwo"
                        label="New Password Confirm"
                        type="password"
                        validations={{
                            minLength: 4,
                            equalsField: 'NewPasswordOne'
                        }}
                        validationErrors={{
                            equalsField: 'Passwords do not match',
                            minLength: 'Min character length is 4'
                        }}
                        required
                        margin="normal"
                        onChange={this.handleChange('NewPasswordTwo')}
                        value={this.state.NewPasswordTwo}
                    />
                    <Button
                        type="submit"
                        variant="raised"
                        color="primary"
                        className="w-full mx-auto mt-16 normal-case"
                    >
                        CHANGE PASSWORD
                    </Button>
                </Formsy>
            </div>
        )

    }

    passwordChanged = prop => {
        return prop ?
            <div>
                <h2>Password successfully updated.</h2>
            </div> : null
    }

    wrongPassword = (prop, sent) => {
        return prop && !sent ?
            <h2>Incorrect Password Entered</h2> :
            null
    }

}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        changePassword: Actions.changePassword,
        checkPassword: Actions.checkPassword
    }, dispatch);
}

function mapStateToProps({ auth }) {
    return {
        auth,
        passwordValid: auth.passwordchange.passwordValid,
        passwordChanged: auth.passwordchange.passwordChanged
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ChangePassword)));


// WEBPACK FOOTER //
// src/main/content/dashboard/components/ChangePassword.js